<template>
  <div class="mt-3">
    <div class="text-secondary text-center">
      <div v-if="user" class="text-center">
        Welcome:
        <span class="font-weight-bold text-dark">{{ user.display_name }}</span>
        <!-- <div v-if="dbInfo">
          <h5 class="font-weight-bold text-success my-2">{{ dbInfo.owner }}</h5>
        </div> -->
      </div>
    </div>
    <div v-if="dbInfo" class="container text-center">
      <div class="row justify-content-center">
        <div class="col-10 col-md-10 col-lg-8 col-xl-7">
          <h4 class="display-4 text-primary mb-2">
            {{ dbInfo.name }}
            <font-awesome-icon
              class="ml-1 text-success"
              icon="seedling"
            ></font-awesome-icon>
          </h4>
          <h5 class="display-5 mb-2">
            {{ dbInfo.owner }}
            <font-awesome-icon
              class="ml-1 text-info"
              icon="dna"
            ></font-awesome-icon>
          </h5>
          <p class="lead text-danger">
            Members Only Site
          </p>

          <router-link
            class="btn btn-outline-primary mb-2 mr-2"
            to="/register"
            v-if="!user"
            >Register</router-link
          >
          <router-link
            class="btn btn-outline-primary mb-2 mr-2"
            to="/login"
            v-if="!user"
            >Login</router-link
          >
          <router-link
            class="btn btn-outline-primary mb-2 mr-2"
            to="/database"
            v-if="user"
            >Database</router-link
          >
          <router-link
            class="btn btn-outline-primary mb-2 mr-2"
            to="/compdb"
            v-if="user"
            >Component</router-link
          >
          <router-link
            class="btn btn-outline-primary mb-2 mr-2"
            to="/design"
            v-if="user"
            >Design</router-link
          >
          <router-link
            class="btn btn-outline-primary mb-2 mr-2"
            to="/snpswap"
            v-if="user"
            >SNPSwap</router-link
          >
        </div>
      </div>

    </div>
    <div v-if="user" class="mt-2 container text-center">
      <div class="card bg-light mb-3">
        <div class="card-header">Status</div>
        <div class="card-body">
          <h5 class="card-title">Phase III: Design</h5>
          <div class="card-text">Progress Report
            <div class="my-3 row justify-content-center">
              <div class="col-10">
                <div class="card border-dark mb-3">
                  <div class="card-header text-dark">Completed</div>
                  <div class="card-body text-dark">
                    <!-- <h5 class="card-title"></h5> -->
                    <p class="card-text">Display Amino acid seq in SNPSwap</p>
                    <p class="card-text">Implement SNPSwap primers CSV download</p>
                    <p class="card-text">Implement SNPSwap primers computation</p>
                    <p class="card-text">Implement SNPSwap frontend module</p>
                    <p class="card-text">Implement Download for full and order primer list</p>
                    <p class="card-text">Implement Reset design feature</p>
                    <p class="card-text">Implement Primer database</p>
                    <p class="card-text">Implement Design database</p>
                    <p class="card-text">Add Decision panel in Design module</p>
                    <p class="card-text">Implement search support for up 5 synonym names</p>
                    <p class="card-text">Implement CJ gene data CSV download support</p>
                    <p class="card-text">Clean up duplicate names in CJ gene data</p>
                    <p class="card-text">Update OLAB Informatics System</p>
                    <p class="card-text">Verify and upload CJ gene data to OLAB Informatics System</p>
                    <p class="card-text">Implement searchable B Number and Synonym Name</p>
                    <p class="card-text">Undo database merge of CJ CGL dataset to OLAB</p>
                    <p class="card-text">Database merge prep: Verify CGL dataset from CJ</p>
                    <p class="card-text">Implement browse and search pagination for Database module</p>
                    <p class="card-text">Improve primer reading by making 5' portion lowercase</p>
                    <p class="card-text">Implement browse and search pagination for Component module</p>
                    <p class="card-text">Implement search support for gene sequence</p>
                    <p class="card-text">Implement Offset setting on (start, range) of sequence</p>
                    <p class="card-text">Improve color scheme of Component module</p>
                    <p class="card-text">Improve visual look of Database module</p>
                    <p class="card-text">Upload 150 RBS package for CJ RBS Test Run</p>
                    <p class="card-text">Up package's components limit to 20</p>
                    <p class="card-text">Add Homology Arm to Library Sequence</p>
                    <p class="card-text">Add User Defined Sequence (UDS) to Sequence Origin</p>
                    <p class="card-text">Design: Implement package's constructs verification view</p>
                    <p class="card-text">Design: Implement package computation</p>
                    <p class="card-text">Enforce no duplicate of sequence in package</p>
                    <p class="card-text">Add package's item sequence to CompDB, Info</p>
                    <p class="card-text">Add RBS to box type selection</p>
                    <p class="card-text">Add RBS Library module</p>
                    <p class="card-text">Design: Implement construct sequence color code view</p>
                    <p class="card-text">Design: Implement special case primer computation</p>
                    <p class="card-text">Design: Implement 3' and 5' primer length settings</p>
                    <p class="card-text">Design: Implement melting temperature computation</p>
                    <p class="card-text">Design: Implement primer computation and length setting</p>
                    <p class="card-text">Design: Implement single construct workflow</p>
                    <p class="card-text">Design: Implement backend save and load support</p>
                    <p class="card-text">Design: Click box to select</p>
                    <p class="card-text">Design: Fixed-size box for single row support</p>
                    <p class="card-text">Design: Add color scheme to box type</p>
                    <p class="card-text">Support easy add/del in cart/package info page</p>
                    <p class="card-text">Design: box-type selection layout</p>
                    <p class="card-text">Component: Improve ATGC color scheme</p>
                    <p class="card-text">Component: Add bar and score charts</p>
                    <p class="card-text">Component: Add initial visual support for package data</p>
                    <p class="card-text">Component: Add initial visual support for sequence data</p>
                    <p class="card-text">Include selected Cart and Package to Information section</p>
                    <p class="card-text">Show selected Cart and Package name display</p>
                    <p class="card-text">Completion: Test and review Component features</p>
                    <!-- <p class="card-text">User Account</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card bg-light mb-3">
        <div class="card-header">Status</div>
        <div class="card-body">
          <h5 class="card-title">Phase II: Component</h5>
          <div class="card-text">Progress Report
            <div class="my-3 row justify-content-center">
              <div class="col-10">
                <div class="card border-dark mb-3">
                  <div class="card-header text-dark">Completed</div>
                  <div class="card-body text-dark">
                    <!-- <h5 class="card-title"></h5> -->
                    <p class="card-text">Cart: Single and Package selections</p>
                    <p class="card-text">Package: Multi components grouping</p>
                    <p class="card-text">Cart: Component accounting feature</p>
                    <p class="card-text">Single part selection</p>
                    <p class="card-text">Selected Project Profile</p>
                    <p class="card-text">Cart: Listing and selection</p>
                    <p class="card-text">Cart: Entry Form</p>
                    <p class="card-text">Cross genomes search feature</p>
                    <p class="card-text">Sequence Library Search function</p>
                    <p class="card-text">Component layout</p>
                    <p class="card-text">Component module setup</p>
                    <!-- <p class="card-text">User Account</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card bg-light mb-3">
        <div class="card-header">Status</div>
        <div class="card-body">
          <h5 class="card-title">Phase I: Database</h5>
          <div class="card-text">Progress Report
            <div class="my-3 row justify-content-center">
              <div class="col-10">
                <div class="card border-dark mb-3">
                  <div class="card-header text-dark">Completed</div>
                  <div class="card-body text-dark">
                    <!-- <h5 class="card-title"></h5> -->
                    <p class="card-text">Sequence Entry update - disallow duplicate</p>
                    <p class="card-text">Gene Search function update - Merge feature</p>
                    <p class="card-text">Locus Tag update - include Old Locus Tag</p>
                    <p class="card-text">Sequence Origin Source Selection</p>
                    <p class="card-text">Strain Library Entry</p>
                    <p class="card-text">Preset: E.coli K-12 substr. W3110</p>
                    <p class="card-text">Preset: C.gl ATCC 13032</p>
                    <p class="card-text">Project Library Entry</p>
                    <p class="card-text">Sequence Library Entry</p>
                    <p class="card-text">User Account</p>
                    <!-- <p class="card-text">User Account</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="my-2">
        <p>Please submit your questions, bugs, feature requests, and contributions at <a
          href="mailto:contact@olabbio.com?subject=Required Action: CJCJ-OLAB Project"
          >contact@olabbio.com</a
        ></p>
      </div>
      <!-- <div class="my-2 row">
        <div class="col-4">col-4</div>
        <div class="col-4">col-4</div>
        <div class="col-4">col-4</div>
      </div>
      <div class="my-2 row">
        <div class="col-4">col-4</div>
        <div class="col-4">col-4</div>
        <div class="col-4">col-4</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "home",
  props: ["user", "dbInfo"],
  components: {
    FontAwesomeIcon
  }
};
</script>
